import React, { Component } from "react";
import List from "@material-ui/core/List";
import ItemAny from "../list-item/ItemAny";
import Typography from "@material-ui/core/Typography";
import { Trans, withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core/styles";
const styles = (theme) => ({
  centerText: {
    marginLeft: "auto",
    marginRight: "auto",
  },
});
export class ListItems extends Component {
  render() {
    const { classes, theme } = this.props
    let items = []
    try {
      items = JSON.parse(this.props.data.items) === null ? [] : JSON.parse(this.props.data.items)
    } catch (err) {
      items = []
    }
    return items.length > 0 ?
    (
      <div style={{marginLeft:theme.spacing(3),marginRight:theme.spacing(3), }}>
      <List>
        {items.map((item, idx) => {
          return <ItemAny key={`${idx}-${item.id}`} data={item} />;
        })}
      </List>
      </div>
    ) :
    (
      <div style={{display:"flex"}}>
        <Typography
          variant="body2"
          className={classes.centerText}
        >
          <Trans i18nKey="portlet_empty" />
        </Typography>
      </div>
    )
  }
}

export default (withTheme(withStyles(styles)(withTranslation()(ListItems))));
